var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSeriesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2123,
    cy: 21.2123,
    r: 15,
    transform: "rotate(45.5155 21.2123 21.2123)",
    fill: "#178477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1817 17L27.9999 21L24.1817 25M27.9999 21H13.9999",
    stroke: "white",
    strokeWidth: 1.88235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSeriesArrow);
export default __webpack_public_path__ + "static/media/btn-series-arrow.357d4be39060864b76113d80d9bb6d5b.svg";
export { ForwardRef as ReactComponent };